import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { Image } from "@/components/ui/image";
import { neighborhoodGuidePath } from "@/lib/neighborhoodPath";
import { useLang } from "@/lib/i18n";
import { neighborhoodCover } from "@/data/neighborhoodMedia";

// A zone the guide has opened but has no photograph for yet still reads as a
// finished editorial card: the same tile, painted in the site's own ink, with
// the area's name and its one-line note over it.
function ZoneTile() {
  return (
    <>
      <div className="absolute inset-0 bg-[#171717] bg-[radial-gradient(120%_90%_at_20%_10%,#3f3f3c_0%,#171717_70%)]" />
      <MapPin
        aria-hidden="true"
        className="absolute right-4 top-6 w-16 h-16 text-white/10"
        strokeWidth={1.25} />
      
    </>);

}

export default function NeighborhoodCard({ item }) {
  const { lang } = useLang();
  const cover = neighborhoodCover(item.name, item.image);
  return (
    <Link
      to={neighborhoodGuidePath(item.name)}
      className="group relative isolate block h-[305px] w-full overflow-hidden rounded-[2px] bg-[#e8e5dd] ring-1 ring-black/[0.10] transition-[box-shadow] duration-300 hover:ring-black/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#b84a3a]/60 focus-visible:ring-offset-2 sm:h-[345px]">
      
      {cover ?
      <Image src={cover} alt={item.name} fittingType="fill" quality={76} className="h-full w-full object-cover transition-transform duration-700 motion-safe:group-hover:scale-[1.035]" /> :

      <ZoneTile />
      }
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/85 transition-opacity duration-300 group-hover:to-black/90" />
      <div aria-hidden="true" className="absolute inset-x-0 top-0 h-1/3 bg-gradient-to-b from-black/30 to-transparent" />
      <div className="absolute right-3.5 top-3.5 z-10 text-white">
        <span className="grid h-9 w-9 place-items-center border border-white/65 bg-black/25 backdrop-blur-sm transition-colors duration-300 group-hover:bg-white group-hover:text-[#171717]">
          <ArrowUpRight aria-hidden="true" className="h-4 w-4" />
        </span>
      </div>
      <div className="absolute bottom-0 left-0 right-0 z-10 p-5 text-white sm:p-6">
        <p className="mb-1.5 flex items-center gap-1.5 text-[9px] font-black uppercase tracking-[0.18em] text-white/70">
          <MapPin aria-hidden="true" className="h-3 w-3 shrink-0" strokeWidth={2.4} />
          {lang === "es" ? "Guía de barrio" : "Neighborhood guide"}
        </p>
        <h3 className="text-balance text-[29px] font-extrabold uppercase leading-[.96] tracking-[-.052em] sm:text-[37px]">{item.name}</h3>
        {item.desc && <p className="mt-2 max-w-[32ch] text-[11.5px] sm:text-[12.5px] leading-[1.45] text-white/78 line-clamp-2">{item.desc}</p>}
        
      </div>
    </Link>);

}